import { useState, useRef, useEffect } from 'react';
import { useNavigation } from '../../utils/redirectUtils';
import { trackPostHogEvent } from '../../utils/posthogUtils';

import styles from './StartMyJourney.module.css';


function StartMyJourney() {
    const [isVisible, setIsVisible] = useState(false);
    const elementRef = useRef(null);
    const navigate = useNavigation();

    const handleHover = (e) => {
        e.target.classList.add('animate__animated', 'animate__pulse', styles.glow);
    };
    const handleHoverEnd = (e) => {
        e.target.classList.remove('animate__animated', 'animate__pulse', styles.glow);
    };    
    const handleStartMyJourney = () => {
        
        // Track submit event

        trackPostHogEvent('landing_page_submitted', {
            selected: 'start_my_journey',
            to_path: '/interview'
        });

        navigate('/interview');
    }    
    
    useEffect(() => {
        const observer = new IntersectionObserver(
        ([entry]) => {
            if (entry.isIntersecting) {
            setIsVisible(true);
            }
        },
        {
            threshold: 0.5,
        }
        );
    
        let currentElement = elementRef.current;
        if (currentElement) {
        observer.observe(currentElement);
        }
        return () => {
        if (currentElement) {
            observer.unobserve(currentElement);
        }
        };
    }, []);

    
    return (
        <div className={styles.journeyButton} ref={elementRef}  onClick={handleStartMyJourney} onMouseEnter={handleHover} onMouseLeave={handleHoverEnd}>
            Start My Weight Loss Journey
        </div>
    );
}

export default StartMyJourney;